import { render, staticRenderFns } from "./FindRelatedOrders.vue?vue&type=template&id=66b97888&scoped=true"
import script from "./FindRelatedOrders.vue?vue&type=script&lang=js"
export * from "./FindRelatedOrders.vue?vue&type=script&lang=js"
import style0 from "./FindRelatedOrders.vue?vue&type=style&index=0&id=66b97888&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66b97888",
  null
  
)

export default component.exports